import { render, staticRenderFns } from "./SetBlockAccount.vue?vue&type=template&id=4df940da"
import script from "./SetBlockAccount.vue?vue&type=script&lang=js"
export * from "./SetBlockAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports